import { ResponsiveSize } from 'src/components/Globals/Globals';
import styled from 'styled-components';

// Container for the page contents. Applies padding to the sides of the page.
export const Container = styled.div`
  padding-right: 3px;
  padding-left: 3px;
  padding-bottom: 20px;
  flex-grow: 1;

  @media (min-width: ${ResponsiveSize.tablet}) {
    padding-right: 40px;
    padding-left: 40px;
  }

  @media (min-width: ${ResponsiveSize.laptop}) {
    padding-right: 80px;
    padding-left: 80px;
  }

  @media (min-width: ${ResponsiveSize.laptopL}) {
    padding-right: 200px;
    padding-left: 200px;
  }

  @media (min-width: ${ResponsiveSize.desktop}) {
    padding-right: 400px;
    padding-left: 400px;
  }
`;

/** Wider version of container that has less horizontal padding on big screens */
export const WideContainer = styled(Container)`
  @media (min-width: ${ResponsiveSize.desktop}) {
    padding-right: 300px;
    padding-left: 300px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Container/Container.tsx